import React from 'react';

type IconProps = {
  src: string;
  fill?: string;
  width?: number;
  height?: number;
  alt?: string;
  className?: string;
};

const Icon = ({
  src,
  fill = 'currentColor',
  width = 24,
  height = 24,
  alt = '',
  className = '',
  ...props
}: IconProps) => (
  <img
    src={src}
    style={{ fill }}
    width={width}
    height={height}
    alt={alt}
    className={className}
    {...props}
  />
);

export default Icon;
